module.exports = __webpack_public_path__ + "img/Courses-Card-Type-2.eef1576e.png";